import { FC } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// Contexts
// Validation Schema or files in the same folder
import { ValidationSchema } from './ValidationSchema';
import { withNavigation, withTenant, withTranslate } from '../../../core/TenantProvider';
import { WithStyles, withStyles } from '@mui/styles';
import SecurityPinContainerStyles from './styles/SecurityPinContainer.style';
import { TranslateFunction } from '../../../core/types/TypographyTypes';
import APPinField from '../APPinField';
import ControllerElementWrapper from '../ControllerWrapper';
import APButton from '../../atoms/APButton';

interface SecurityPinScreenProps extends WithStyles<typeof SecurityPinContainerStyles> {
  translate: TranslateFunction;
  loadingState: string;
  settings: any;
  goToBackPage: Function;
  onOTPSubmit: Function;
  isDuplicateEmail: boolean;
  formData: any
}

export interface SecurityPinType {
  securityPin: string[];
}

const SecurityPinScreen: FC<SecurityPinScreenProps> = (props: SecurityPinScreenProps) => {
  const { translate, classes, isDuplicateEmail, onOTPSubmit, goToBackPage, formData } = props;

  let pinFieldSize: 'large' | 'medium' | 'small' = 'medium';

  const {
    handleSubmit,
    control,
    formState: { isValid }
  } = useForm<any>({
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: yupResolver(ValidationSchema())
  });

  const headerText: string = translate('become.partner.form.otp.header');
  const headerSubText: string = translate('become.partner.form.otp.subheader', { phone_number: formData?.mobile.input.slice(-4) });


  // Scrolls to the top of the content area
  window.scrollTo(0, 0);

  const onSubmit: SubmitHandler<SecurityPinType> = (data) => {
    onOTPSubmit && onOTPSubmit(data);
  };

  const navigateToBackPage = () => {
    goToBackPage && goToBackPage()
  };

  const handlePinChange = () => {

  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} data-testid="Ap-form-security-pin-screen">
      <div className={classes.setupPinContainer}>
        <div className={classes.setupPinTitle}>
          <h1>{headerText}</h1>
          <p>{headerSubText}</p>
        </div>
        <div className={classes.pinFieldContainer}>
          <ControllerElementWrapper
            name={'securityPin'}
            control={control}
            defaultValue={['', '', '', '', '']}
            component={APPinField}
            length={5}
            size={pinFieldSize}
            handleChange={handlePinChange}
          />
        </div>
        <div className={classes.stepButtons}>
          <div className={classes.stepButtonsLeft}>
            <APButton
              children={translate('become.partner.form.otp.back.button')}
              className={classes.stepButton}
              color='primary'
              variant='outlined'
              onClick={navigateToBackPage}
            />
          </div>
          <div className={classes.stepButtonsRight}>
            <APButton
              children={translate('become.partner.form.otp.confirm.button')}
              className={classes.stepButton}
              color='primary'
              disabled={!isValid || isDuplicateEmail}
              variant='contained'
              type='submit'
            />
          </div>
        </div>
      </div>
    </form>
  );
};

export default
  withNavigation(
    withTenant(
      withTranslate(
        withStyles(SecurityPinContainerStyles)(
          SecurityPinScreen
        )
      )
    )
  );
